import { css } from 'emotion';
import React from 'react';

interface ITierLine {
    name: string;
    color: string;
}

const TierLine = ({ name, color }: ITierLine): React.ReactElement => {
    return (
        <div
            className={css({
                display: 'grid',
                gridTemplateColumns: 'fit-content(100%) auto',
            })}
        >
            <div
                data-testid="tier-dot"
                className={css({
                    background: color,
                    alignSelf: 'center',
                    borderRadius: '50%',
                    width: '14px',
                    height: '14px',
                })}
            />

            <div
                className={css({
                    display: 'grid',
                    gridTemplateColumns: 'fit-content(100%) auto',
                    justifyItems: 'end',
                    alignItems: 'center',
                    padding: '8px 16px 8px 12px',
                })}
            >
                <p data-testid="tier-name">{name}</p>
            </div>
        </div>
    );
};

export default TierLine;
